import { Observable } from 'rxjs';
import {
  ExtractionForEdit,
  UpdateExtractionData
} from '../../../model/associate-extraction/edit/edit-extraction.model';

export abstract class EditExtractionRepository {
  abstract searchExtraction(searchCode: string): Observable<ExtractionForEdit>;

  abstract updateExtraction(data: UpdateExtractionData): Observable<void>;
}
